import { render, staticRenderFns } from "./detailSkillsRadar.vue?vue&type=template&id=69a365c5"
import script from "./detailSkillsRadar.vue?vue&type=script&lang=js"
export * from "./detailSkillsRadar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports